const DIRECT_SEARCH_HINTS = [
  'avis',
  'ticket',
  'plaque',
  'immatriculation',
  'numero',
];

const normalizeText = value => String(value || '')
  .trim()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase();

export const normalizeAssistantQuery = value => String(value || '').trim();

const cleanSearchTerm = value => String(value || '')
  .trim()
  .replace(/^[#:]+/, '')
  .replace(/[.,;:!?]+$/, '')
  .replace(/\s+/g, ' ');

const normalizeCompactTerm = value => cleanSearchTerm(value).replace(/[^A-Za-z0-9]/g, '');

const getExplicitSearchTerm = query => {
  const patterns = [
    /\b(?:avis|ticket|numero|num[e\u00e9]ro|no\.?)\s*(?:#|:|-)?\s*([A-Za-z]?-?\d{4,}|[0-9]{5,})\b/i,
    /\b(?:plaque|immatriculation)\s*(?:#|:|-)?\s*([A-Za-z0-9][A-Za-z0-9\s-]{1,12})\b/i,
  ];

  for (const pattern of patterns) {
    const match = query.match(pattern);

    if (match && match[1]) {
      return cleanSearchTerm(match[1]);
    }
  }

  return '';
};

export const extractDirectSearchTerm = query => {
  const value = normalizeAssistantQuery(query);

  if (!value) {
    return '';
  }

  const explicitTerm = getExplicitSearchTerm(value);

  if (explicitTerm) {
    return explicitTerm;
  }

  const compactTerm = normalizeCompactTerm(value);
  const hasSpaces = /\s/.test(value);
  const normalizedValue = normalizeText(value);
  const hasSearchHint = DIRECT_SEARCH_HINTS.some(hint => normalizedValue.includes(hint));

  if (hasSpaces && !hasSearchHint) {
    return '';
  }

  if (/^\d{4,}$/.test(compactTerm)) {
    return compactTerm;
  }

  if (/^[A-Z0-9]{2,10}$/i.test(compactTerm) && /[A-Za-z]/.test(compactTerm)) {
    return compactTerm;
  }

  return '';
};

export const getAssistantIntent = query => {
  const normalized = normalizeText(query);

  if (!normalized) {
    return 'empty';
  }

  if (extractDirectSearchTerm(query)) {
    return 'direct-search';
  }

  if (
    normalized.includes('vehicule')
    || normalized.includes('surveiller')
    || normalized.includes('alerte')
    || normalized.includes('plus de 5')
    || normalized.includes('5 avis')
  ) {
    return 'vehicle-alerts';
  }

  if (
    normalized.includes('paiement')
    || normalized.includes('paye')
    || normalized.includes('payes')
    || normalized.includes('montant')
    || normalized.includes('$')
  ) {
    return 'payments';
  }

  if (
    normalized.includes('contestation')
    || normalized.includes('conteste')
    || normalized.includes('contester')
  ) {
    return 'contestations';
  }

  if (
    normalized.includes('fraicheur')
    || normalized.includes('sync')
    || normalized.includes('retard')
    || normalized.includes('mis a jour')
  ) {
    return 'freshness';
  }

  if (
    normalized.includes('activite')
    || normalized.includes('semaine')
    || normalized.includes('7 jours')
    || normalized.includes('recent')
  ) {
    return 'activity';
  }

  if (
    normalized.includes('avis emis')
    || normalized.includes('avis emis')
    || normalized.includes('24 h')
    || normalized.includes('24h')
    || normalized.includes('aujourd')
    || normalized.includes('hier')
  ) {
    return 'issued-notices';
  }

  return 'unknown';
};
